export function getMessageText(type) {
    switch (type) {
        case "tip":
            return "You have received %1 tokens from";
        
        case "new_follower":
            return "You have a new follower";
        
        case "gift":
            return "has given you a virtual gift!";

        case "message":
            return "has sent you a new message.";

        case "new_message":
            return "new message";

        case "guestbook_message":
            return "You have a new message at your Guest book from";

        case "guestbook_first":
            return "You have a";

        case "guestbook_second":
            return "at your Guest book from";

        case "membership_gift":
            return "has given you an XXL membership for %1 days!";

        case "membership_gift_public":
            return "has given an XXL membership to";

        case "wall":
            return "has posted at the Wall";

        case "wall_short":
            return "has posted at";

        case "followed_user_is_online":
            return "just connected to the room";

        case "new_personal_room":
            return "has opened a room My BobTV";

        case "new_showroom":
            return "started show My BobTV";

        case "user_membership_expired":
            return "Your XXL membership has expired at %1.";

        case "user_membership_almost_expired":
            return "Your XXL membership will expire at %1.";
    
        case "stream_record_error":
            return "There was a problem with recording of your video clip.";

        case "pm_message":
            return "has sent you a new message."
    }
}



// WEBPACK FOOTER //
// ./src/utils/notifications.js